import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const nagios = defineConnector({
  identifier: "nagios",
  name: "Nagios",
  tagLine: "Infrastructure monitoring and alerting",
  logo,
  protocol: "http",
  tags: ["observability", "it"],
  defaultUrlPattern: ({ serverUrl }) => domainToRegex(serverUrl),
  auth: (app) => queryAuth([{ name: "apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your Nagios API credentials",
      items: [
        {
          kind: "markdown",
          content: `1. In Nagios XI, go to **Admin › System Config › API**
2. Find or generate an API key for your user
3. Copy the key`,
        },
      ],
    },
    {
      title: "Enter your Nagios details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://nagios.example.com",
          target: { kind: "configuration", field: "serverUrl" },
          helperText: "The base URL of your Nagios instance.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ serverUrl }) => `${serverUrl}/nagiosxi/api/v1/system/status`,
  },
});
